var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12496 8.50002C5.31246 8.50002 8.49996 5.31252 8.49996 2.12502C8.49996 5.31252 11.6875 8.50002 14.875 8.50002C11.6875 8.50002 8.49996 11.6875 8.49996 14.875C8.49996 11.6875 5.31246 8.50002 2.12496 8.50002ZM1.41663 13.8125C2.00667 13.8125 3.18746 12.6317 3.18746 12.0417C3.18746 12.6317 4.36825 13.8125 4.95829 13.8125C4.36825 13.8125 3.18746 14.9933 3.18746 15.5834C3.18746 14.9933 2.00667 13.8125 1.41663 13.8125ZM11.3333 3.54169C12.0416 3.54169 13.4583 2.12502 13.4583 1.41669C13.4583 2.12502 14.875 3.54169 15.5833 3.54169C14.875 3.54169 13.4583 4.95835 13.4583 5.66669C13.4583 4.95835 12.0416 3.54169 11.3333 3.54169Z",
    stroke: "#27304D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.304f1b60c346b9ad18a37b1c64a9f950.svg";
export { ForwardRef as ReactComponent };